import { Injectable } from '@angular/core';
import { SlideshowItem } from '../models/slideshow-item';
import { Guid, isNil, Nillable } from '@web/utils';
import { AssetImage } from '../../image/enums/asset-image';
import { RequiredMethodCallException } from '@web/common';

@Injectable({
  providedIn: 'root',
})
export class SlideshowItemBuilder {
  private _id: Nillable<Guid>;
  private _image: Nillable<AssetImage>;
  private _alt: Nillable<string>;

  public newInstance(): SlideshowItemBuilder {
    return new SlideshowItemBuilder();
  }

  public id(id: Guid): this {
    this._id = id;

    return this;
  }

  public image(image: AssetImage): this {
    this._image = image;

    return this;
  }

  public alt(alt: string): this {
    this._alt = alt;

    return this;
  }

  public reset(): this {
    this._id = null;
    this._image = null;
    this._alt = null;

    return this;
  }

  public build(): SlideshowItem {
    this.requireId();
    this.requireImage();
    this.requireAlt();

    const item = new SlideshowItem(this._id!, this._image!, this._alt!);

    this.reset();

    return item;
  }

  private requireId(): void {
    if (isNil(this._id)) {
      throw new RequiredMethodCallException(this.id.name);
    }
  }

  private requireImage(): void {
    if (isNil(this._image)) {
      throw new RequiredMethodCallException(this.image.name);
    }
  }

  private requireAlt(): void {
    if (isNil(this.alt)) {
      throw new RequiredMethodCallException(this.alt.name);
    }
  }
}
